<ng-container *ngIf="loading">
  <ul>
    <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7]">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </ul>
</ng-container>
<div class="alerts-popover-content" *ngIf="!loading">
  <ul
    class="alerts-list"
    [hidden]="showBrokers || showNotif || showLineItemDeltaConfig"
  >
    <li *ngFor="let data of allEventTypes">
      <div
        class="main-values display-flex flex-align-center"
        (click)="onClickEventType(data)"
        *ngIf="
          data.display_name !== 'Line Item Delta' ||
          (data.display_name === 'Line Item Delta' &&
            alertsDataToSend.line_item_delta)
        "
      >
        <va-icon size="small" [isFontAwesome]="true" [name]="faBell" class="icon" *ngIf="!data.checked"></va-icon
        ><va-icon
          size="small"
          class="icon"
          name="bell"
          *ngIf="data.checked"
        ></va-icon>
        <span
          [nz-tooltip]="data.showTitle ? true : null"
          [nzTooltipTitle]="data.showTitle ? data.titleText : null"
          [nzTooltipOverlayStyle]="{ fontSize: '12px', width: '160px' }"
          [nzTooltipPlacement]="'right'"
          >{{ data.display_name }}</span
        >
      </div>
      <ul
        *ngIf="key !== '-1' && data.display_name === 'New Model'"
        class="sub-values"
      >
        <li
          class="brokers-option"
          (click)="showBrokersChange(true)"
          [attr.disabled]="disabledBrokers ? true : null"
        >
          Brokers ({{ selectedBrokers.length }} of {{ brokerList.length }})
          <va-icon
            size="small"
            class="icon icon-size"
            style="margin-left: 3px;"
            name="chevron-right"
          ></va-icon>
        </li>
      </ul>
      <ul
        *ngIf="
          key !== '-1' &&
          data.display_name === 'Line Item Delta' &&
          triggerType !== 'watchlist'
        "
        class="sub-values"
      >
        <li
          *ngIf="alertsDataToSend.line_item_delta"
          class="brokers-option"
          (click)="showLineItemDeltaChange(true)"
          [attr.disabled]="
            !alertsDataToSend.line_item_delta.subscribed ? true : null
          "
        >
          Parameters
          <va-icon
            size="small"
            class="icon icon-size"
            style="margin-left: 3px;"
            name="chevron-right"
          ></va-icon>
        </li>
      </ul>
      <ul
        *ngIf="data.subcategories && data.subcategories.length > 0"
        class="sub-values"
      >
        <li>
          <nz-checkbox-wrapper
            style="width: 100%;"
            (nzOnChange)="onEPChanges()"
            class="check-box-group"
          >
            <div>
              <div
                class="checkbox-sm"
                *ngFor="let subVal of data.subcategories"
              >
                <label
                  nz-checkbox
                  nzValue="{{ subVal.display_name }}"
                  [(ngModel)]="subVal.checked"
                  class="checkbox-label"
                  >{{ subVal.display_name }}</label
                >
              </div>
            </div>
          </nz-checkbox-wrapper>
        </li>
      </ul>
    </li>
    <li *ngIf="key !== '-1'" (click)="showNotifChange(true)">
      <div class="main-values">
        <va-icon
          size="small"
          class="icon icon-size"
          style="margin-right: 3px;"
          name="chevron-right"
        ></va-icon>
        <span>Email Frequency</span>
      </div>
    </li>
  </ul>

  <ul class="broker-list" [hidden]="!showBrokers">
    <li (click)="showBrokersChange(false)">
      <va-icon
        size="small"
        class="icon icon-size"
        style="margin-right: 3px;"
        name="chevron-left"
      ></va-icon>
      Brokers
    </li>
    <div class="checkbox-sm">
      <label
        nz-checkbox
        nzValue="All Entitled"
        [(ngModel)]="allEntitledBrokers"
        class="checkbox-label"
        (ngModelChange)="onChangeAllEntitled()"
        >All Entitled</label
      >
    </div>
    <nz-checkbox-wrapper
      style="width: 100%;"
      (nzOnChange)="onBrokerChanges($event)"
      class="check-box-group"
    >
      <div style="max-height: 180px; overflow-x: auto;">
        <div class="checkbox-sm" *ngFor="let data of brokerList">
          <label
            nz-checkbox
            nzValue="{{ data.broker_name }}"
            [(ngModel)]="data.checked"
            class="checkbox-label"
            >{{ data.broker_name }} <span *ngIf="data.analyst_name">|</span>
            {{ data.analyst_name }}</label
          >
        </div>
      </div>
    </nz-checkbox-wrapper>
  </ul>
  <ul class="notification-list" [hidden]="!showNotif">
    <li (click)="showNotifChange(false)">
      <va-icon
        size="small"
        class="icon icon-size"
        style="margin-right: 3px;"
        name="chevron-left"
      ></va-icon>
      Email Frequency
    </li>
    <nz-checkbox-wrapper
      style="width: 100%;"
      (nzOnChange)="onNotificationChanges($event)"
      class="check-box-group"
    >
      <div class="checkbox-sm">
        <label
          nz-checkbox
          nzValue="instant"
          [(ngModel)]="notificationOptions.instant"
          class="checkbox-label"
          >As it Happens</label
        >
      </div>
      <div class="checkbox-sm">
        <label
          nz-checkbox
          nzValue="daily"
          [(ngModel)]="notificationOptions.daily"
          class="checkbox-label"
          >Daily Digest</label
        >
      </div>
      <div class="checkbox-sm">
        <label
          nz-checkbox
          nzValue="weekly"
          [(ngModel)]="notificationOptions.weekly"
          class="checkbox-label"
          >Weekly Digest</label
        >
      </div>
    </nz-checkbox-wrapper>
  </ul>

  <ul class="lid-list" *ngIf="showLineItemDeltaConfig">
    <div class="lid-parameter" (click)="showLineItemDeltaChange(false)">
      <va-icon size="small" class="icon icon-size" name="chevron-left"></va-icon>
      Parameters
    </div>
    <app-line-item-delta-alert
      [showSubscription]="false"
      [data]="alertsDataToSend.line_item_delta"
      (lidAlertDataChanged)="onLidAlertChange($event)"
    ></app-line-item-delta-alert>
  </ul>
  <button
    class="set-btn"
    nz-button
    nzType="primary"
    nzSize="small"
    [disabled]="disabledSetButton"
    (click)="onClickSet()"
  >
    {{ okBtnText }}
  </button>

  <button
    *ngIf="showCancelButton"
    class="cancel-btn"
    nz-button
    nzSize="small"
    (click)="onClickCancel()"
  >
    Cancel
  </button>
</div>
